import React, { useState, useContext } from 'react'
import { AuthUserContext, withAuthentication } from '../Session'
import { FirebaseContext } from '../../server/Firebase'
import MeetingLink from '../MeetingLink'
import MiscVideoModal from '../MiscVideoModal'

const Burnout = ({})=>{
    const firebase = useContext(FirebaseContext)
    const meeting = firebase.useMiscMeeting({ session: 'burnout' })
    const user = useContext(AuthUserContext)
  return (
  <div class="flex flex-col items-center">
		<header>
			<h1 className="text-center pt-3 pb-1 text-3xl">Joint CEDAR-GEM Sessions Addressing Burnout</h1>
		</header>
		<div className="max-w-3xl mx-2">
      <p className="text-center pb-3 text-xl">Rebecca Pope-Ruark  (agilefaculty.rpr@gmail.com)</p>
      <div className='flex justify-center pb-2'>
        {meeting?.link && (
          <p className='flex gap-2'>
            Join us remotely!{' '}
            {<MeetingLink link={meeting.link} info={meeting.linkInfo} />}
          </p>
        )}
        {user?.isAdmin && (
          <MiscVideoModal
            session='burnout'
            initialVideoLink={meeting?.link}
            initialVideoInfo={meeting?.linkInfo}
          />
        )}
      </div>

      <h2 className='text-xl'>Compassionate Leadership for Burnout</h2>
      <p className='pb-3'>Leaders can have a big impact on those they lead when it comes to stress and burnout. In this workshop, we’ll explore what burnout is and how it impacts individuals and organizations, then learn to have a compassionate conversation with a direct report or colleagues you suspect may be experiencing burnout.</p>

      <h2 className='text-xl'>Unraveling Burnout for Scientists</h2>
      <p className='pb-3'>It’s a challenging time to be a scientist right now, and levels of burnout are higher than ever. But what is burnout, exactly, and how does it impact us as researchers or academics? What can you do to mitigate burnout in your day-to-day work? In this workshop, we will examine what burnout is and where it comes from and then look at three lenses for mitigating the impacts of burnout on individuals: articulating purpose, leveraging connections, and creating balance.</p>
      <h2 className='text-xl'>Small Group Coaching</h2>
      <p className='pb-3'>Coaching is a practice that stirs up creativity, fuels personal growth, and maximizes both professional and personal potential (ICF). In these small group sessions, we will explore ways to think about current workplace challenges and goals. We’ll explore personal experiences with burnout and brainstorm strategies for mitigating its effects.</p>
    </div>
  </div>)}

export { Burnout }


